import { useMediaQuery, useTheme } from '@material-ui/core';

/**
 * Returns a boolean representing if the current device is mobile or not
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

/**
 * Returns a boolean representing if the current device is a desktop or not
 */
export function useIsDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('lg')); // This is the breakpoint used in a different part of the codebase
}
